import { useQuery } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

export interface ContainerData {
  uuid: string;
  title: string;
  numberOfNodes: number;
  sizeBytes: number;
  schema: string;
  dynamic: boolean;
}

export function useGetContainer(uuid: string) {
  const { keycloak } = useKeycloak();

  return useQuery({
    queryKey: ['container', uuid],
    enabled: !!uuid,
    queryFn: async (): Promise<ContainerData> => {
      const response = await fetch(
        `${
          import.meta.env.VITE_USER_ENGINE_ENDPOINT
        }/api/v1/bundles/user_bundle/functions/get_container`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${keycloak.token}`,
          },
          method: 'POST',
          body: JSON.stringify({ containerUuid: uuid }),
        }
      );

      const data = await response.json();

      return data?.data;
    },
  });
}
